import { render, staticRenderFns } from "./SignupFormView.vue?vue&type=template&id=7623a2e4&scoped=true&"
import script from "./SignupFormView.vue?vue&type=script&lang=js&"
export * from "./SignupFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7623a2e4",
  null
  
)

export default component.exports